import { useResumeBulkJobToasts } from '../hooks/use-resume-bulk-job-toasts';

/** Renders nothing; brings back the progress toasts of bulk jobs still running. */
export function BulkJobToastsMount() {
    useResumeBulkJobToasts();
    return null;
}
